import {get} from '../../../assets/js/utils/api';
import {toNode} from "../../../assets/js/utils/dom";

export function initPostLists() {
    return [...document.querySelectorAll('.b-vehicle-list:not(.-initialized)')].map(node => new PostList(node))
}

class PostList {
    dom = {
        wrapper: null,
        postList: null,
        buttons: {
            filters: [],
            loadMore: null
        }
    }

    state = {
        isLoading: false,
        page: 1,
        taxonomy: null,
        term: null,
        postTypes: null,
        filters: {},      // <-- Add filters to state
    }

    config = {
        postTypes: ['vehicle'],
        perPage: -1,
        order: 'desc',
        orderBy: 'date'
    }

    constructor(wrapper) {
        this.dom.wrapper = wrapper
        this.state.page = parseInt(wrapper.dataset.page)
        this.config.postTypes = wrapper.dataset.postTypes.split(',')
        this.config.perPage = parseInt(wrapper.dataset.perPage)
        this.config.order = wrapper.dataset.order
        this.config.orderBy = wrapper.dataset.orderBy

        // ADD THIS: Parse backend filters attribute and store in state
        try {
            this.state.filters = JSON.parse(wrapper.getAttribute('data-filters')) || {}
        } catch {
            this.state.filters = {}
        }

        this.findNodes()
        this.attachListeners()
    }

    findNodes() {
        this.dom.buttons.filters = [...this.dom.wrapper.querySelectorAll('[data-action="filter"]')]
        this.dom.buttons.loadMore = this.dom.wrapper.querySelector('[data-action="load-more"]')
        this.dom.postList = this.dom.wrapper.querySelector('.b-vehicle-list__posts')
    }

    attachListeners() {
        this.dom.buttons.filters.forEach(btn => {
            btn.addEventListener('keydown', e => {
                if(e.key === 'Escape') this.applyStateFilter(btn)
            })
            btn.addEventListener('click', e => {
                this.applyStateFilter(btn)
            })
        })
        this.dom.buttons.loadMore?.addEventListener('click', e => this.loadMore())
        this.dom.buttons.loadMore?.addEventListener('keydown', e => {
            if(e.key === 'Escape') this.loadMore()
        })
    }

    async applyStateFilter(filterButton) {
        if(this.state.isLoading) return;

        this.dom.wrapper.dataset.activeAction = 'filter'
        this.dom.buttons.filters.forEach(btn => btn.setAttribute('aria-selected', btn === filterButton ? 'true' : 'false'))

        if(filterButton.dataset.type === 'reset') {
            this.state.term = null
            this.state.taxonomy = null
            this.state.postTypes = null
            this.state.page = 1
        } else if(filterButton.dataset.type === 'WP_Post_Type') {
            this.state.postTypes = filterButton.dataset.postType
            this.state.page = 1
        } else if(filterButton.dataset.type === 'WP_Term') {
            this.state.taxonomy = filterButton.dataset.tax
            this.state.term = filterButton.dataset.term
            this.state.page = 1
        }

        const res = await this.applyState()
        this.dom.postList.innerHTML = res.html;
    }

    async loadMore() {
        if(this.state.isLoading) return;

        this.dom.wrapper.dataset.activeAction = 'load-more'
        this.state.page += 1;
        const res = await this.applyState()

        const htmlContent = toNode(`<div>${res.html}</div>`);
        [...htmlContent.children].forEach(child => this.dom.postList.append(child))
    }

    async applyState() {
        this.state.isLoading = true;
        this.dom.wrapper.setAttribute('aria-busy', 'true')

        // Make sure vehicle only explicitly:
        const data = {
            page: this.state.page,
            postTypes: ['vehicle'],
            perPage: this.config.perPage,
            orderBy: this.config.orderBy,
            order: this.config.order,
            filters: JSON.stringify(this.state.filters),
        }

        // In case you use frontend filters (optional, keep these if you need them)
        if(this.state.taxonomy) data.taxonomy = this.state.taxonomy
        if(this.state.term) data.term = this.state.term

        let json

        try {
            const res = await get('block-vehicle-list/index', data)
            json = await res.json()
            if(this.dom.buttons.loadMore) {
                this.dom.buttons.loadMore.style.display = json.hasMorePages ? 'block' : 'none'
            }
            return json
        } catch (error) {
            console.error(error)
            window.alert('Something went wrong...')
        } finally {
            if(this.dom.buttons.loadMore) {
                this.dom.buttons.loadMore.style.display = json.hasMorePages ? 'block' : 'none'
            }
            this.dom.wrapper.setAttribute('aria-busy', 'false')
            this.state.isLoading = false;
        }
    }
}
